import { Search } from '@mui/icons-material';
import { TextField, TextFieldProps } from '@mui/material';
import { useEffect, useRef } from 'react';

type Props = Omit<TextFieldProps, 'onChange' | 'variant' | 'fullWidth' | 'size'> & {
  loading: boolean;
  onChange: (value: string) => void;
};

export const SearchInput = ({ onChange, loading, disabled, ...rest }: Props) => {
  const ref = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (!loading && ref.current) {
      ref.current.focus();
    }
  }, [loading]);

  return (
    <TextField
      variant="filled"
      fullWidth
      size="small"
      disabled={disabled || loading}
      InputProps={{ endAdornment: <Search /> }}
      inputProps={{ ref }}
      onChange={(e) => onChange(e.target.value)}
      {...rest}
    />
  );
};
